import { styled } from '@mui/system';

// componente para fazer link de chamada telefonica sem underline
  export const MyLink = styled('a')({
    textDecoration: 'none',
  });